<div class="cowing-tabs">
  <div class="tab" (click)="setActive(EActiveTab.Explore)">
    <img *ngIf="activeTab !== EActiveTab.Explore" [src]="getExploreIcon">
    <img *ngIf="activeTab === EActiveTab.Explore" [src]="getExploreIconActive">
    <span [ngClass]="{'active': activeTab === EActiveTab.Explore}">{{ 'coworker.tabs.explore' | translate }}</span>
  </div>
  <div class="tab" (click)="setActive(EActiveTab.Office)">
    <img *ngIf="activeTab !== EActiveTab.Office" [src]="getBriefcaseIcon">
    <img *ngIf="activeTab === EActiveTab.Office" [src]="getBriefcaseIconActive">
    <span [ngClass]="{'active': activeTab === EActiveTab.Office}">{{ 'coworker.tabs.office' | translate }}</span>
  </div>
  <div class="tab" (click)="setActive(EActiveTab.Booking)">
    <img *ngIf="activeTab !== EActiveTab.Booking" [src]="getBookingIcon">
    <img *ngIf="activeTab === EActiveTab.Booking" [src]="getBookingIconActive">
    <span [ngClass]="{'active': activeTab === EActiveTab.Booking}">{{ 'coworker.tabs.booking' | translate }}</span>
  </div>
  <div class="tab" (click)="setActive(EActiveTab.Profile)">
    <img *ngIf="activeTab !== EActiveTab.Profile" [src]="getProfileIcon">
    <img *ngIf="activeTab === EActiveTab.Profile" [src]="getProfileIconActive">
    <span [ngClass]="{'active': activeTab === EActiveTab.Profile}">{{ 'coworker.tabs.profile' | translate }}</span>
  </div>

</div>
